/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { NotificationSchema } from './notificationSchema';

export interface NotificationListResponse {
  items: NotificationSchema[];
  next_cursor?: string | null;
  total_unread: number;
}
